import { Container, AppBar, Toolbar, IconButton, Typography, TextField, Box } from '@mui/material';
import { ArrowBackOutlined } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme, maskPhone } from '../functions/utils';
import * as React from 'react';

import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Snackbar from '@mui/material/Snackbar';
import LoadingComponent from '../components/LoadingComponent';

import '@fontsource/roboto/400.css';
import { SpacerMely } from '../components/DesignSystem/SpacerMely';
import { ButtonMely } from '../components/DesignSystem/ButtonMely';

function InformacoesPerfil() {

  const state = useLocation().state;
  const [loading, setLoading] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [msgSnack, setMsgSnack] = useState(false);
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [modalAlert, setModalAlert] = React.useState(false);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/", { replace: true, state: { page: "perfil" } })
  };

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleOpenModal = (titleModal, descriptionModal) => {
    setTitle(titleModal);
    setDescription(descriptionModal);
    setModalAlert(true);
    handleCloseLoading();
  };

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const handleCloseModal = () => {
    setModalAlert(false);
  };

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store.png?${new Date().getTime()}`;

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    const nomeUsuario = localStorage.getItem('nmUsr');
    const telefoneUsuario = localStorage.getItem('tUsr');
    const emailUsuario = localStorage.getItem('emUsr');
    setNome(nomeUsuario);
    setTelefone(telefoneUsuario);
    setEmail(emailUsuario);
    handleCloseLoading();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNomeChange = (event) => {
    setNome(event.target.value);
    setIsButtonDisabled(!(email !== "" && telefone !== "" && nome !== ""));
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setIsButtonDisabled(!(email !== "" && telefone !== "" && nome !== ""));
  };

  const handleTelefoneChange = (event) => {
    setTelefone(maskPhone(event.target.value));
    setIsButtonDisabled(!(email !== "" && telefone !== "" && nome !== ""));
  };

  const handleSalvar = () => {
    handleOpenLoading();
    if (email !== "" && telefone !== "" && nome !== "") {
      const idusuarios = localStorage.getItem('iUsr');
      const urlBase = localStorage.getItem('UBs');
      axios.post(`${urlBase}/editar-dados.php`, {
        idusuarios: idusuarios,
        telefone: telefone,
        nome: nome
      })
        .then(response => {
          response = response.data
          if (!response) {
            handleOpenModal("", "Não foi possivel salvar seus dados, verifique sua conexão e tente novamente.")
            return
          }
          if (response.resposta === "sucesso atualizar") {
            localStorage.setItem('nmUsr', nome);
            localStorage.setItem('tUsr', telefone);
            handleSnack("Informações do perfil salvas com sucesso.");
            setTimeout(handleBack, 3000);
            return
          }
          handleOpenModal("", "Não foi possivel salvar seus dados, verifique sua conexão e tente novamente.")
        })
        .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
    }
  };



  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>

        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            Informações de perfil
          </Toolbar>
        </AppBar>

        <LoadingComponent open={loading} />

        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleClose}
          message={msgSnack}
        />

        <Dialog
          open={modalAlert}
          onClose={handleCloseModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ p: "12px" }}>
              <ButtonMely onClick={handleCloseModal}>Fechar</ButtonMely>
            </Box>
          </DialogActions>
        </Dialog>

        <SpacerMely height={83} />

        <>

          <Typography style={{ fontSize: "12px", color: "#464444", fontWeight: "bold" }}>
            Nome
          </Typography>

          <SpacerMely height={6} />

          <TextField
            fullWidth
            hiddenLabel
            value={nome}
            onChange={handleNomeChange}
            variant="outlined"
            size="small"
            placeholder="Digite seu nome"
            type="text"
          />

          <SpacerMely height={25} />

          <Typography style={{ fontSize: "12px", color: "#464444", fontWeight: "bold" }}>
            Telefone
          </Typography>

          <SpacerMely height={6} />

          <TextField
            fullWidth
            hiddenLabel
            value={telefone}
            onChange={handleTelefoneChange}
            variant="outlined"
            size="small"
            placeholder="Digite seu telefone"
            type="text"
          />

          <SpacerMely height={25} />

          <Typography style={{ fontSize: "12px", color: "#464444", fontWeight: "bold" }}>
            E-mail
          </Typography>

          <SpacerMely height={6} />

          <TextField
            fullWidth
            hiddenLabel
            value={email}
            onChange={handleEmailChange}
            variant="outlined"
            size="small"
            placeholder="Digite seu e-mail"
            type="email"
            disabled
          />

          <SpacerMely height={32} />

          <ButtonMely disabled={isButtonDisabled} onClick={handleSalvar}>Salvar</ButtonMely>

        </>

        <SpacerMely height={100} />

      </Container>
    </ThemeProvider>
  );
}

export default InformacoesPerfil;